import { commAxiosRequest } from "zr-util/src/utils/comm/commAxiosRequest";
import settingHelp from "@/config/localSetting";
const config = settingHelp.getConfig();
const { baseURL } = config;
let service = commAxiosRequest({ baseURL: baseURL });
export default service;

export function request(opt) {
  return service(opt);
}

export function resetRequest() {
  const newConfig = settingHelp.getConfig();
  const { baseURL } = newConfig;
  service = commAxiosRequest({ baseURL: baseURL });
}
